<template>
  <div class="table-container">
    <table v-if="reviews.length > 0">
      <thead>
      <tr>
        <th>Data</th>
        <th>Cliente</th>
        <th>Nota</th>
        <th>Comentário</th>
        <th class="text-center">Status</th>
        <th class="actions-header">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="r in reviews" :key="r.id" :class="{ approved: r.aprovado }">
        <td>{{ new Date(r.created_at).toLocaleDateString() }}</td>
        <td><strong>{{ r.nome_cliente }}</strong></td>
        <td>
            <span class="stars-display">
              {{ '★'.repeat(r.nota) }}<span class="dim">{{ '★'.repeat(5 - r.nota) }}</span>
            </span>
        </td>
        <td class="comment-cell">{{ r.comentario }}</td>
        
        <td class="text-center">
          <span :class="['status-badge', r.aprovado ? 'approved' : 'pending']">
            {{ r.aprovado ? 'Publicado' : 'Revisão' }}
          </span>
        </td>
        
        <td class="actions-cell">
          <button
            v-if="!r.aprovado"
            @click="aprovar(r)"
            class="action-btn approve"
            title="Publicar Avaliação"
          >
            <span class="material-icons-outlined">check_circle</span>
          </button>
          
          <button
            v-else
            @click="ocultar(r)"
            class="action-btn hide"
            title="Ocultar (Voltar para Revisão)"
          >
            <span class="material-icons-outlined">visibility_off</span>
          </button>
          
          <button @click="deletar(r)" class="action-btn delete" title="Excluir Definitivamente">
            <span class="material-icons-outlined">delete</span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div v-else class="empty-state">Nenhuma avaliação encontrada.</div>
  </div>
</template>

<script>
import api from '@/services/api';
import { AlertBus } from '@/plugins/AlertBus';

export default {
  name: "AdminAvaliacoes",
  data() { return { reviews: [] } },
  mounted() { this.fetchReviews(); },
  methods: {
    async fetchReviews() {
      try {
        const res = await api.get('/api/admin/avaliacoes');
        this.reviews = res.data;
      } catch(e) { console.error(e); }
    },
    async aprovar(r) {
      try {
        await api.put(`/api/admin/avaliacoes/${r.id}/aprovar`);
        r.aprovado = true;
        AlertBus.$emit('show-alert', { message: 'Avaliação publicada!', type: 'success' });
      } catch(e) {
        AlertBus.$emit('show-alert', { message: 'Erro ao aprovar.', type: 'erro' });
      }
    },
    async ocultar(r) {
      try {
        await api.put(`/api/admin/avaliacoes/${r.id}/ocultar`);
        r.aprovado = false;
        AlertBus.$emit('show-alert', { message: 'Avaliação ocultada.', type: 'info' });
      } catch(e) {
        AlertBus.$emit('show-alert', { message: 'Erro ao ocultar.', type: 'erro' });
      }
    },
    async deletar(r) {
      if(!confirm('Tem certeza? Isso apagará a avaliação permanentemente.')) return;
      try {
        await api.delete(`/api/admin/avaliacoes/${r.id}`);
        this.reviews = this.reviews.filter(item => item.id !== r.id);
        AlertBus.$emit('show-alert', { message: 'Avaliação excluída.', type: 'success' });
      } catch(e) {
        AlertBus.$emit('show-alert', { message: 'Erro ao excluir.', type: 'erro' });
      }
    }
  }
};
</script>

<style scoped src="@/assets/admin-styles.css"></style>
<style scoped>
.stars-display { color: #FFD700; letter-spacing: 2px; }
.dim { color: #555; }
.comment-cell {
  max-width: 300px;
  font-size: 0.9rem;
  font-style: italic;
  color: var(--text-secondary);
}

/* Centralização */
.text-center { text-align: center; }
.actions-header { text-align: center; } /* Header da coluna Ações */
.actions-cell { text-align: center; white-space: nowrap; } /* Conteúdo da coluna Ações */

/* Botões Específicos */
.action-btn.approve { border-color: #4CAF50; color: #4CAF50; }
.action-btn.approve:hover { background-color: rgba(76, 175, 80, 0.1); }

.action-btn.hide { border-color: #FF9800; color: #FF9800; }
.action-btn.hide:hover { background-color: rgba(255, 152, 0, 0.1); }

.action-btn.delete { border-color: #F44336; color: #F44336; }
.action-btn.delete:hover { background-color: rgba(244, 67, 54, 0.1); }

/* Status Badge Específico (se não usar o global) */
.status-badge {
  font-size: 0.75rem;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
  text-transform: uppercase;
  display: inline-block;
}
.status-badge.approved { background-color: rgba(76, 175, 80, 0.15); color: #4CAF50; border: 1px solid #4CAF50; }
.status-badge.pending { background-color: rgba(255, 152, 0, 0.15); color: #FF9800; border: 1px solid #FF9800; }

tr.approved { background-color: rgba(76, 175, 80, 0.02); }
</style>